import MaterialsNotFound from "./MaterialsNotFound";

export default MaterialsNotFound;